import classNames from 'classnames';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import SectionContainer from 'components/Containers/SectionContainer';
import Label from 'components/form/Label/Label';
import Disclaimer from 'components/AdvertiserToolTip';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { ReactComponent as ArrowDown } from 'style/icons/lg-chevron-down.svg';
import { scrollToClassInner } from 'hook/helper.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { AVAILABLE_FOR_YOU } from 'types/morph.pagePosition.constants';
import { OfferCard } from './OfferCard';
import { GlossyCreditCardOffer } from './GlossyCreditCardOffer';

import './AvailableForYouModuleView.scss';

const AvailableForYouModuleView = props => {
  const {
    className,
    history,
    offersCards,
    eventHandler,
    creditCardOfferMetaData,
    modulePosition,
    seenModuleTracking,
  } = props;

  return (
    <SectionContainer
      className={classNames(
        'availableForYou padB0 flex-column gap-16',
        className,
      )}
      margin="margB0"
      background="bgGrey005"
    >
      {seenModuleTracking}
      <FlexContainer className="m-flex-column m-items-align-center justify-between margB12 bold">
        <Label className="text-20 margL8 m-margL0">Available for You</Label>
        <Disclaimer className="margT8 m-hide" />
      </FlexContainer>
      <StaticOfferContainer
        offerMetadataList={[creditCardOfferMetaData]}
        eventHandler={props.eventHandler}
        pagePosition={AVAILABLE_FOR_YOU}
        creditCardTemplate={GlossyCreditCardOffer}
        modulePosition={modulePosition}
        showAmexWithConfidence={props?.showAmexWithConfidence}
      />
      <div
        className="offersContainer gap-10"
        data-elements={offersCards?.length}
      >
        {offersCards?.map((offerCard, index) => (
          <OfferCard
            key={index}
            {...offerCard}
            history={history}
            eventHandler={eventHandler}
            modulePosition={modulePosition}
          />
        ))}
      </div>
      <FlexContainer className="flex-column items-align-center margT16 margB4 d-hide">
        <Label
          onClick={() => {
            eventHandler(CLICK, {
              'Click Type': 'Show More',
              'Module Position': modulePosition,
              'Module Name': AVAILABLE_FOR_YOU,
            });
            scrollToClassInner('marketplace-offer-container');
          }}
          className="text-14"
        >
          Show More Offers <ArrowDown aria-label="ArrowDown" />
        </Label>
      </FlexContainer>
    </SectionContainer>
  );
};

export default AvailableForYouModuleView;
